import { request } from '@services'

export const state = {
  loading: false,
  data: null,
  errors: null,
  resisterErrors: null,
}

export const getters = {
  getDeviceList(state) {
    return state.data
  },
  getRegisterErrors() {
    return state.resisterErrors
  },
}

export const mutations = {
  SET_DEVICE_LIST_REQUESTED(state) {
    state.loading = true
  },
  SET_DEVICE_LIST_RECEIVED(state, newData) {
    state.loading = false
    state.data = newData
    state.errors = null
  },
  SET_DEVICE_LIST_RECEIVED_FAILED(state, error) {
    state.loading = false
    state.errors = error
  },
  SET_DEVICE_REGISTER_FAILED(state, error) {
    state.loading = false
    state.resisterErrors = error
  },
  RESET_DEVICE_LIST(state) {
    state.loading = false
    state.data = null
    state.errors = null
  },
}

export const actions = {
  async fetchingDeviceList({ commit }, params) {
    commit('SET_DEVICE_LIST_REQUESTED')
    try {
      const response = await request({
        endpoint: '/cms/device/list/',
        payload: { ...params },
      })
      commit('SET_DEVICE_LIST_RECEIVED', response)
      return response
    } catch (error) {
      commit('SET_DEVICE_LIST_RECEIVED_FAILED', error)
    }
  },
  resetDeviceList({ commit }) {
    commit('RESET_DEVICE_LIST')
  },
  async deleteDeviceById({ commit }, params) {
    try {
      const response = await request({
        endpoint: '/cms/device/delete/',
        payload: { ...params },
      })
      return response
    } catch (error) {
      return error
    }
  },
  async editDeviceById({ commit }, params) {
    try {
      const response = await request({
        endpoint: '/cms/device/edit/',
        payload: { ...params },
      })
      return response
    } catch (error) {
      return error
    }
  },
  async registerDevice({ commit }, params) {
    try {
      const response = await request({
        endpoint: '/cms/device/add/',
        payload: { ...params },
      })
      return response
    } catch (error) {
      commit('SET_DEVICE_REGISTER_FAILED', error)
      return error
    }
  },
}
